import { NgModule } from '@angular/core';

import { ManutencoesComponent } from './manutencoes.component';
import { SharedModule } from "../shared/shared.module";
import { ManutencoesRoutingModule } from "./manutencoes-routing.module";
import { ServicosModule } from "./servicos/servicos.module";
import { PlanosModule } from "./planos/planos.module";
import { OdometrosHorimetrosModule } from "./odometros-horimetros/odometros-horimetros.module";
import { OrdensServicoModule } from "./ordens-servico/ordens-servico.module";
import { ManutencaoConfiguracaoComponent } from "./configuracao/manutencao-configuracao.component";
import { ManutencaoMenuComponent } from "./shared/manutencao-menu/manutencao-menu.component";
import { ManutencaoService } from "./shared/manutencao.service";
import { ManutencaoProgramadaModule } from "./manutencao-programada/manutencao-programada.module";

@NgModule({
    imports: [
        SharedModule,
        ServicosModule,
        PlanosModule,
        OdometrosHorimetrosModule,
        OrdensServicoModule,
        ManutencaoProgramadaModule,
        ManutencoesRoutingModule
    ],
    providers: [
        ManutencaoService
    ],
    declarations: [
        ManutencoesComponent,
        ManutencaoConfiguracaoComponent,
        ManutencaoMenuComponent
    ],
    exports: [
        ManutencaoMenuComponent
    ]
})
export class ManutencoesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencoes.module.ts
 **/